import log from 'rawr/utils/log';

define([
  'angular',
  'mod',
  'angular-ui-router',
  'common/Notifications/Notifications',
  'common/Utils',
  'common/TopBar/TopBar'
], function(angular, mod) {

require('!!file?name=xdomain.js!vendor/xdomain');
require('!!file?name=xdomain.html!xdomain.html');

var m = require('am');
require('common/errors');

__webpack_public_path__ = window.base_static_url;

var timeout_html = `
  <p>{{ item.message }}</p>
  <a class="btn right btn--color_red btn--size_small"
    ng-click="item.reload()"
    style="margin-bottom: 1.25rem;$">
    Reload</a>
`

m.config(['$locationProvider', '$httpProvider', '$urlRouterProvider', 'config',
 function($locationProvider, $httpProvider, $urlRouterProvider, config) {
  $locationProvider.html5Mode(!config.hash_urls);
  $httpProvider.interceptors.push('urlRewriter');
  $httpProvider.interceptors.push('infinityPreventor');
  $httpProvider.interceptors.push('httpResponseErrorInterceptor');
  $httpProvider.interceptors.push('ajaxLogger');

  $urlRouterProvider.otherwise('/');
}]);

m.config(['$sceDelegateProvider', 'config', function($sceDelegateProvider, config) {
  $sceDelegateProvider.resourceUrlWhitelist([
    'self',
    config.static_url + '**',
  ]);
}]);

m.factory('httpResponseErrorInterceptor', ['$q', '$injector', 'notify', '$window',
 function($q, $injector, notify, $window) {
  return {
    responseError: function(response) {
      if (response.config && 'status' in response) {
        var retry = response.config['@@retry'] || 0;
        var retry_after = _.parseInt(response.headers('Retry-After'));
        if (response.status === 0 || retry_after) {
          if (retry < 4) {
            var $http = $injector.get('$http');
            var deferred = $q.defer();
            response.config['@@retry'] = retry + 1;
            var delay_seconds = retry_after || 0.2;
            var delay = Math.pow(2, response.config['@@retry']) * delay_seconds * 1000;
            delay = 500;

            setTimeout(function() {
              $http(response.config)
                .then(function(r) {
                  deferred.resolve(r);
                })
                .catch(function(e) {
                  deferred.reject(e);
                });
            }, delay);
            return deferred.promise;
          } else {
            notify.error('Network Error. Please save your work and reload.', {
              template: timeout_html,
              reload: function() {
                $window.location.reload();
              }
            });
            return $q.reject(response);
          }
        }
        return $q.reject(response);
      }
    }
  };
}]);

m.factory('urlRewriter', ['config', function(config) {
  // Rewrites outgoing ajax requests to point at the static folder for any relative urls.
  return {
    request: function(request) {
      if (request.url.indexOf('/') !== 0 && request.url.indexOf('://') === -1) {
        request.url = (config.static_url || '') + request.url;
      }
      return request;
    }
  };
}]);

m.factory('infinityPreventor', [function() {
  // If a mistake is made in defining a partial path, angular may request it
  // relative to the document root. Flask will serve up the app .html page, thus
  // creating a loop that will lock up the page.
  return {
    response: function(response) {
      if (response.data.substr && response.data.substr(0, 50).indexOf('<!DOCTYPE html>') !== -1) {
        throw {
          'response': response,
          'error': 'Response appears to be a base html page: ' + response.config.url
        };
      } else {
        return response;
      }
    }
  };
}]);

function error_message(error) {
  if (_.isUndefined(error)) {
    return 'Undefined error';
  } else if ((typeof error) === 'string') {
    return error;
  } else if (error && error.message) {
    return error.message;
  }

  var message;
  if ('status' in error && !error.status) {
    message = 'Network error or timeout';
  } else if ('status' in error) {
    message = (error.data && error.data.message) ||
      (error.statusText && (error.status + ' ' + error.statusText)) ||
      'HTTP Error';
  }

  if ((typeof message) !== 'string') {
    message = angular.toJson(message);
  }
  return message;
}

m.factory('ajaxLogger', ['$log', function($log) {
  return {
    response: function(response) {
      const {url, method} = response.config;
      if (response.config.url.indexOf('api') !== -1 && !(method.toUpperCase() == 'POST' && url == '/n/api/current_user')) {
          $log.debug([method, url, JSON.stringify(response)].join(' : '));
      }
      return response;
    }
  };
}]);

m.factory('sendToRaven', ['$window', '$log', function($window, $log) {
  return function(exception, extra) {
    var info = _.assign({
        exception: exception,
        log: log.getCollected()
    }, extra);
    if (exception instanceof Error) {
      $window.Raven.captureException(exception, {extra: info});
    } else {
      $window.Raven.captureMessage(error_message(exception), {extra: info});
    }
  };
}]);

m.run(['$rootScope', '$state', '$stateParams', 'notify', '$window', '$document', '$location', 'config', '$log', 'sendToRaven',
 function($rootScope, $state, $stateParams, notify, $window, $document, $location, config, $log, sendToRaven) {
  $rootScope.$state = $state;
  $rootScope.$stateParams = $stateParams;
  $rootScope.config = config;
  $rootScope._ = _;

  $rootScope.$on('$stateChangeStart', function(ev, toState, toParams, fromState, fromParams) {
    if (fromState.data && fromState.data.public && !toState.data.public) {
      if (toState.name === 'portal') {
        $window.location.href = '/';
      } else {
        ev.preventDefault();
        $window.location.href = $state.href(toState, toParams);
        $window.location.reload();
      }
    }
  });

  _.forEach(['$stateChangeError', '$stateNotFound'], function(name) {
    $rootScope.$on(name, function(event, toState, toParams, fromState, fromParams, error) {
      if (error) error['@@logged'] = true;
      sendToRaven(error, {
        extra: {
          fromState: {
            name: fromState.name,
            params: fromParams
          },
          toState: {
            url: $location.absUrl(),
            name: toState.name,
            params: toParams
          },
          error: error
        }
      });

      var close = notify.error('Error loading page');
      var stop_listening;
      function close_error() {
        close();
        stop_listening();
      }
      stop_listening = $rootScope.$on('$stateChangeStart', close_error);

      $log.error([event.name, toState.name, angular.toJson(toParams)].join(' | '),
        {error: error, event:event, toState:toState, toParams:toParams, fromState:fromState, fromParams:fromParams});
      throw error;
    });
  });
}]);

m.run(['$rootScope', '$window', '$location', '$log', '$browser',
 function($rootScope, $window, $location, $log, $browser) {

  var start_time, timed_state;
  $rootScope.$on('$stateChangeStart', function(event, toState) {
    timed_state = toState.name;
    start_time = new Date().getTime();
  });
  $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams) {
    $window.scrollTo(0,0);

    var page = ($browser.baseHref() + $location.path()).replace('//', '/');
    $log.log(['State change', page, toState.name, angular.toJson(toParams)].join(' | '));
    $window.ga('send', 'pageview', page);
    if (toState.name === timed_state) {
      $window.ga('send', {
        hitType: 'timing',
        timingCategory: 'Page Load',
        timingVar: toState.name,
        timingValue: ((new Date().getTime()) - start_time),
        page: page,
      });
    }
  });
}]);

m.directive('body', function(){
  return {
    restrict: 'E',
    link: function($scope,$elem){
      $scope.$on('$overlayShow', function(ev,args){
        if(args.type === 'modal'){
          $elem.addClass('modal_active');
        }
      });
      $scope.$on('$overlayHide', function(ev){
        $elem.removeClass('modal_active');
      });
    }
  };
});

m.factory('$exceptionHandler', ['$window', '$log', 'sendToRaven',
 function ($window, $log, sendToRaven) {
  return function (exception, cause) {
    if (_.isUndefined(exception)) {
      return;
    }
    if (exception.message && exception.message.indexOf('insertBefore') !== -1 && exception.message.indexOf('null') !== -1) {
      return;
    }

    $log.error.apply($log, arguments);

    if (!exception['@@logged']) {
      sendToRaven(exception, {cause: cause});
    }
  };
}
]);


// https://github.com/angular-ui/ui-router/issues/76
m.config(['$stateProvider', function($stateProvider) {
    // bouncer state
    $stateProvider.state('bounce', {
        controller: ['$state', '$stateParams', function($state, $stateParams) {
            // just redirect to caller
            $state.go(
                $stateParams.state,
                JSON.parse($stateParams.params)
            );
        }]
    });
}]);
m.run(['$state', '$stateParams', function($state, $stateParams) {
    // override reload so it uses the bouncer.
    $state.reload = function() {
        return this.go('bounce', {
            state: $state.current.name,
            params: JSON.stringify($stateParams) // only strings can be passed
        });
    };
}]);

m.directive('activeClass', function() {
  return {
    link: function($scope, $elem, $attrs) {
      $scope.$watch(function() {
        return !!$elem.data('$uiView');
      }, function(active) {
        if (active) {
          $elem.addClass($attrs.activeClass);
        } else {
          $elem.removeClass($attrs.activeClass);
        }
      });
    }
  };
});

return m;
});



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/Routing.js
 **/